<template>
  <div class="menu">
    <basiCcontainer title="侧边栏配置">
      <el-container>
        <el-header class="menu-header">
          <el-button-group>
            <el-button type="primary" icon="icon iconfont iconicon_enlarge" size="small" @click.native="handleAddOne">新增一级菜单</el-button>
            <el-button type="primary" icon="icon iconfont iconicon_enlarge" size="small" @click.native="handleAdd">新增</el-button>
            <el-button type="primary" icon="el-icon-edit" size="small" @click.native="handleEdit">编辑</el-button>
            <el-button type="primary" icon="el-icon-delete" size="small" @click.native="handleDel" :loading="delBtn">删除</el-button>
          </el-button-group>
        </el-header>
      </el-container>
      <el-container>
        <div class="treeLeft">
          <el-aside width="300px">
            <el-tree :data="menuAll" node-key="id" highlight-current default-expand-all :expand-on-click-node="false" :loading="treeLoading" @node-click="handleNodeClick"></el-tree>
          </el-aside>
        </div>
        <div class="treeRight">
          <el-main>
            <el-form ref="form" :model="form" label-width="80px">
              <el-form-item label="父菜单ID">
                <el-input v-model="form.parentId" :disabled="true"></el-input>
              </el-form-item>
              <el-form-item label="父菜单">
                <el-input v-model="form.parentMenu" :disabled="true"></el-input>
              </el-form-item>
              <el-form-item label="菜单名称">
                <el-input v-model="form.menuName" placeholder="请输入菜单名" clearable :disabled="formGrade"></el-input>
              </el-form-item>
              <el-form-item label="菜单类型">
                <el-select v-model="form.menuType" placeholder="请选择" :disabled="formGrade" clearable>
                  <el-option v-for="item in menuType" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="菜单路径">
                <el-input v-model="form.menuUrl" placeholder="请输入菜单路径" clearable :disabled="formGrade"></el-input>
              </el-form-item>
              <el-form-item label="菜单授权">
                <el-input v-model="form.perms" placeholder="请输入菜单权限" clearable :disabled="formGrade"></el-input>
              </el-form-item>
              <el-form-item label="菜单图标">
                <el-input v-model="form.icon" clearable placeholder="请输入菜单图标" :disabled="formGrade"></el-input>
              </el-form-item>
              <el-form-item label="菜单排序">
                <el-input v-model="form.sortOrder" clearable placeholder="请输入菜单排序" :disabled="formGrade"></el-input>
              </el-form-item>
              <el-form-item label="菜单备注">
                <el-input type="textarea" placeholder="请输入菜单备注" clearable :autosize="{ minRows: 6, maxRows: 10}" v-model="form.remark" size="medium" :disabled="formGrade"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="handleSubmit" :disabled="formGrade" :loading="addBtn" v-if="formStatus=='add'">新增</el-button>
                <el-button type="primary" @click="updateSubmit" :disabled="formGrade" :loading="updateBtn" v-if="formStatus=='edit'">修改</el-button>
              </el-form-item>
            </el-form>
          </el-main>
        </div>
      </el-container>
    </basiCcontainer>
  </div>
</template>

<script>
import { validatenull, validatenum } from "@/utils/validate";
import { findParent, findParentID } from "@/utils/utils";
import { mapActions, mapState } from "vuex";
import basiCcontainer from "@/layouts/app/components/basiCcontainer";
export default {
  components: {
    basiCcontainer
  },
  name: "imenu",
  data() {
    return {
      form: {},
      obj: {},
      parentForm: {},
      formGrade: true,
      formStatus: "",
      addBtn: false,
      updateBtn: false,
      treeLoading: false,
      delBtn: false,
      menuType: [
        {
          value: 1,
          label: "菜单"
        },
        {
          value: 2,
          label: "按钮"
        }
      ]
    };
  },
  created() {
  },
  mounted() {
    this.init();
    const height =
      document.getElementsByClassName("el-main")[0].offsetHeight -
      document.getElementsByClassName("menu-header")[0].offsetHeight -
      120;
    document.getElementsByClassName(
      "treeLeft"
    )[0].style.height = `${height}px`;
    document.getElementsByClassName(
      "treeRight"
    )[0].style.height = `${height}px`;
  },
  computed: {
    ...mapState("layout/layout", {
      menuAll: state => state.menu
    })
  },
  props: [],
  methods: {
    ...mapActions("layout/layout", [
      "GetMenuListPage",
      "AddMenu",
      "EditMenu",
      "DeleteMenu"
    ]),
    reg() {
      if (this.form.sortOrder === '') {
        this.$message({
          showClose: true,
          message: "菜单排序不能为空",
          type: "warning"
        });
        return false
      }
      if (validatenum(this.form.sortOrder, 2)) {
        this.$message({
          showClose: true,
          message: "菜单排序只能输入整数",
          type: "warning"
        });
        return false
      }

      return true
    },
    handleAddOne() {
      this.formGrade = false;
      this.formStatus = "add";
      this.form = {};
      this.form.parentId = 0
      this.form.parentMenu = '';
    },
    init() {
      this.treeLoading = true;
      this.GetMenuListPage({})
        .then(() => {
          this.treeLoading = false;
        })
        .catch(err => {
          this.treeLoading = false;
        });
    },
    handleNodeClick(data, checked, indeterminate) {
      this.form = data;
      this.formGrade = true;
      this.formStatus = "";
      this.obj = data;
      this.form = data;
    },
    handleAdd() {
      if (!this.form.parentId) {
        message({
          showClose: true,
          message: "请先选择子菜单",
          type: "warning"
        });
        return;
      }
      this.formGrade = false;
      this.formStatus = "add";
      let obj = {};
      obj = JSON.parse(JSON.stringify(this.form));
      this.form = {};
      this.form.parentId = obj.id;
      this.form.parentMenu = obj.menuName;
    },
    handleEdit() {
      if (validatenull(this.obj)) {
        this.$message({
          showClose: true,
          message: "请选择菜单",
          type: "warning"
        });
        return;
      }
      this.form = Object.assign({}, this.obj);
      this.formStatus = "edit";
      this.formGrade = false;
    },
    async handleDel() {
      if (!this.form.id) {
        this.$message({
          showClose: true,
          message: "请选择菜单",
          type: "warning"
        });
        return;
      }
      await this.$wfAlert('warning', `是否确认删除菜单为${this.form.menuName}`)
      this.delBtn = true;
      this.DeleteMenu({ id: this.form.id })
        .then(() => {
          this.delBtn = false;
          this.$message({
            showClose: true,
            message: "删除成功",
            type: "success"
          });
          this.init();
        })
        .catch(err => {
          this.delBtn = false;
        });
    },
    handleSubmit() {
      if (!this.reg()) {
        return
      }
      this.addBtn = true;
      this.formGrade = true;
      this.AddMenu(this.form)
        .then(() => {
          this.init();
          this.addBtn = false;
          this.formGrade = false;
          this.$alert("新增成功", "提示", {
            type: "success",
            confirmButtonText: "确定",
            callback: action => {
            }
          });
        })
        .catch(err => {
          this.addBtn = false;
          this.formGrade = false;
        });
    },
    updateSubmit() {
      if (!this.reg()) {
        return
      }
      this.updateBtn = true;
      this.formGrade = true;
      this.EditMenu(this.form)
        .then(() => {
          this.init();
          this.updateBtn = false;
          this.formGrade = false;
          this.$alert("修改成功", "提示", {
            type: "success",
            confirmButtonText: "确定",
            callback: action => {
            }
          });
        })
        .catch(err => {
          this.updateBtn = false;
          this.formGrade = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.menu-container {
  padding: 0 20px;
}
.menu-header {
  padding: 8px 0;
}
.menu {
  .treeLeft,
  .treeRight {
    overflow-x: hidden;
  }
  .treeRight {
    width: 100%;
  }
  .el-aside {
    overflow: hidden;
  }
}
</style>
